import BaseRegulation from "../base_regulation";
import {CANADA_STATES_LIST, COUNTRY_ISO3} from "../../../country/country_consts";
import Device from '../../../../utils/device';

export default abstract class COMBaseRegulation extends BaseRegulation{
    static CLASS = 'COMBaseRegulation';

    checkIfCorrectAppInUse(country:string, state: string) {
        const canadaWrongAppAppsFlyerSmartLink = "https://888casino-ca.onelink.me/3A45/wrongAppCta?pid=cta_WrongApp&af_sub2=";

        if (Device.isHybrid() && Device.isIOS() && country === COUNTRY_ISO3.CANADA && state === CANADA_STATES_LIST.ONTARIO) {
            this.serviceFactory.hybridVersionHandlerService().showUserWrongAppMessage(canadaWrongAppAppsFlyerSmartLink + this.serviceFactory.hybridService().getSmartLinkData());
            this.sendAnalytics('userWrongAppMessage', 'show');
        }
    }

    shouldCallCountryByIP(country) {
        return country === COUNTRY_ISO3.CANADA;
    }

    private sendAnalytics(category:string, action:string):void {
        const analyticsData:any = {
            category: category,
            action: action
        };

        this.logger.debug(action, JSON.stringify(analyticsData));
        this.serviceFactory.structuredLoggingService().getLogger(analyticsData).info();
    }
}